import { money, recommendedBase, gpFromBase as gpFromSp } from "./quotePricingPolicy";

// A persisted selection reference alone is not evidence of an available quote.
export function selectedPartQuote(part) {
  if (part?.selected_quote_id == null) return null;
  return availablePartQuotes(part).find(quote => String(quote.id) === String(part.selected_quote_id)) ?? null;
}

export function availablePartQuotes(part) {
  return (part?.supplier_quotes ?? part?.quotes ?? []).filter(quote => String(quote.quote_status ?? quote.status ?? "").toLowerCase() !== "disabled");
}

// Cost → recommended GP%/SP pair from the tier table (null gp/sp when cost is empty).
export function recommendedPricing(costPrices, cost) {
  return cost == null ? { gp: null, sp: null } : recommendedBase(costPrices, cost);
}
export function storedBasePrice(part, quote, ranges) {
  if (part.selling_price != null) {
    return Number(part.quoted_base_sp_snapshot != null && money(part.selling_price) === money(Number(part.quoted_base_sp_snapshot) + Number(part.internal_delivery_allocation || 0))
      ? part.quoted_base_sp_snapshot : part.selling_price);
  }
  return recommendedBase(ranges, Number(quote?.quoted_price || 0)).sp;
}

export function seedQuotePricing(prev, parts, costPrices) {
  const next = { ...prev };
  parts.forEach(p => {
    (p.supplier_quotes ?? []).forEach(q => {
      const cp = Number(q.quoted_price || 0);
      if (next[q.id]?._cp === cp) return; // preserve edits until the supplier cost changes
      if (next[q.id]) { next[q.id] = { ...recommendedPricing(costPrices, cp), _cp: cp }; return; }
      if (p.selected_quote_id === q.id && p.selling_price != null) {
        const sp = storedBasePrice(p, q, costPrices);
        next[q.id] = { sp, gp: gpFromSp(cp, sp), _cp: cp };
      } else {
        const rec = recommendedPricing(costPrices, cp);
        next[q.id] = { sp: rec.sp, gp: rec.gp, _cp: cp };
      }
    });
  });
  return next;
}
